import { FC, ReactElement } from "react";
import styles from "./customiser.module.css";
import classNames from "classnames";
import { Option } from "./Option";

interface CustomiserProps {
  options: {
    value: number;
    title: string;
    subTitle?: string;
    totalDiff?: number;
    totalDiffTitle?: string;
    details?: ReactElement | null;
    disabled?: boolean;
    disabledMessage?: string;
  }[];
  direction?: "row" | "column";
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  noBadge?: boolean;
  showSigned?: boolean;
  slim?: boolean;
  name: string;
}

const Customiser: FC<CustomiserProps> = ({
  options,
  direction,
  value,
  onChange,
  disabled,
  noBadge,
  showSigned = true,
  slim,
  name,
}) => {
  return (
    <div
      className={classNames(
        styles.options,
        direction === "column" && styles.column,
        options.length >= (slim ? 4 : 3) && styles.mobileColumn
      )}
    >
      {options.map((option) => {
        const isActive = !disabled && value === option.value;
        return (
          <Option
            key={option.value}
            onChange={onChange}
            option={option}
            disabled={disabled}
            isActive={isActive}
            noBadge={noBadge}
            showSigned={showSigned}
            slim={slim}
            details={option.details}
            name={name}
          />
        );
      })}
    </div>
  );
};

export default Customiser;
